import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

try {
    // window.Popper = require('@popperjs/core').default;
    // window.Popper = require('popper.js').default;
    // window.$ = window.jQuery = require('jquery');
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');

    // import * as Popper from '@popperjs/core'
    // window.Popper = Popper
    // import 'bootstrap'
} catch (e) {}